export { default } from './index.vue'



// WEBPACK FOOTER //
// ./packages/dof-digital-panel/index.js